<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.querymodel.SectionIds" placeholder="请选择路段" collapse-tags
        :clearable="true" :multiple="true" @change="getList()">
        <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName" :value="item.Id"></el-option>
      </el-select>
      <el-select v-if="ProductId == 2" class="filter-item" v-model="listQuery.querymodel.BrandId" placeholder="请选择商户"
        collapse-tags :clearable="true" @change="getList()">
        <el-option v-for="item in brandlist" :key="item.Id" :label="item.BrandName" :value="item.Id"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.paywayids" placeholder="请选择支付方式" collapse-tags
        :clearable="true" :multiple="true" @change="getList()">
        <el-option v-for="item in paywaylist" :key="item.Id" :label="item.PaywayName" :value="item.Id"></el-option>
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.paytype" placeholder="请选择款项"
        @change="getList()">
        <el-option label="出场收款" :value="1"></el-option>
        <el-option label="补缴收款" :value="2"></el-option>
        <el-option label="预收款" :value="4"></el-option>
        <!-- <el-option label="手动退款" :value="3"></el-option> -->
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.source"
        placeholder="请选择支付渠道" @change="getList()">
        <el-option label="自助缴费" :value="1"></el-option>
        <el-option label="收费员收费" :value="2"></el-option>
        <el-option label="商户缴费" :value="3"></el-option>
      </el-select>
      <el-select style="margin-right: 10px" :clearable="true" v-model="listQuery.querymodel.paymode" placeholder="请选择类型"
        @change="getList()">
        <el-option label="收款" :value="1"></el-option>
        <el-option label="退款" :value="2"></el-option>
      </el-select>
      <el-date-picker @change="datechange" class="filter-item" v-model="querydate" type="datetimerange"
        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
      </el-date-picker>
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="车牌号" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe ref="orderrecordtable" show-summary
      :summary-method="getSummaries" style="width: 100%" :height="getViewHeight()"
      :header-cell-style="{ background: '#F3F4F7', color: '#555' }" :row-style="{ height: '10px' }"
      :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width" :formatter="col.formatter == true ? tableformatter : null">
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
  </div>
</template>
<script>
import { GetPaydetailRecord } from "@/api/order";
import { query as querybrand } from "@/api/brand"
import { query as querysectionlist } from "@/api/section";
import { querypayway as queryway } from "@/api/payway";
import { MrYangUtil } from "../../utils/time.js";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
export default {
  components: { Pagination, Toolbar },
  directives: { waves },
  data() {
    return {
      brandlist: [],
      ProductId: 1,
      dialogshow: false,
      buttonList: [],
      downloadLoading: false,
      authedit: false,
      authdelete: false,
      list: [],
      pageIndex: 1,
      total: 0,
      orderrecordmain: {},
      buscost: {
        dialogshow: false,
        editform: {},
        isedit: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let s = MrYangUtil.getCurrentWeek()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentWeek()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let s = MrYangUtil.getCurrentMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              let s = MrYangUtil.getPreviousMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getPreviousMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              let s = MrYangUtil.getCurrentYear()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentYear()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
        ],
      },
      querydate: "",
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 100,
        },
        { label: "支付时间", value: "PayTime", align: "center", type: "" },
        { label: "支付流水号", value: "Id", align: "center", type: "" },
        { label: "支付金额", value: "PayAmount", align: "center", type: "" },
        { label: "支付方式", value: "PaywayName", align: "center", type: "" },
        { label: "第三方支付单号", value: "PayOrderNo", align: "center", type: "" },
        { label: "支付来源", value: "SourceName", align: "center", type: "" },
        { label: "款项", value: "PayTypeName", align: "center", type: "" },
        { label: "类型", value: "PayModeName", align: "center", type: "" },
        { label: "路段", value: "SectionName", align: "center", type: "" },
        { label: "车牌号码", value: "LicencePlate", align: "center", type: "" },
        { label: "操作人", value: "EmpName", align: "center" },
        { label: "停车订单号", value: "SaleId", align: "center" }
      ],
      paywaylist: [],
      servicetime: 0,
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
          SectionIds: [],
          EmpIds: [],
          paywayids: [],
          begintime: "",
          endtime: "",
          source: "",
          paytype: "",
          paymode: ""
        },
      },
    };
  },
  created() {
    try {
      this.ProductId = window.localStorage.ProductId;
      if (this.ProductId == 2) {
        querybrand({ pageSize: 10000, }).then(res => {
          this.brandlist = res.data;
        });
      }
      let userinfo = JSON.parse(window.localStorage.getItem("user"));
      let stime = userinfo.syspara.filter((it) => it.ParaKey === "ht17")[0]
        .ParaValue;
      let ssstime = new Date(stime);
      let sstime = new Date();
      sstime.setSeconds(0);
      sstime.setHours(ssstime.getHours());
      sstime.setMinutes(ssstime.getMinutes());
      if (sstime.getTime() < new Date().getTime()) {
        this.servicetime =
          sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000;
      } else {
        this.servicetime = -(
          3600 * 1000 * 24 -
          (sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000)
        );
      }
    } catch {
      this.servicetime = 0;
    }
    const end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    const start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setTime(start.getTime() + this.servicetime);
    end.setTime(end.getTime() + this.servicetime);
    this.querydate = [start, end];
    this.listQuery.querymodel.begintime = start;
    this.listQuery.querymodel.endtime = end;
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    queryway({
      pageSize: 10000,
    }).then((res) => {
      this.paywaylist = res.data;
      if (this.ProductId == 2) {
        this.paywaylist.push({ Id: "1513733238194184192", PaywayName: "商户余额" })
      }
    });
    this.getList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["orderrecordtable"].doLayout();
    });
  },
  methods: {
    tableformatter(row, column, cellValue) {
      switch (column.property) {
        case "PayAmount":
          return Number(cellValue).toFixed(2);
      }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计：";
          return;
        }
        if (this.orderrecordmain[column.property] != undefined) {
          sums[index] = Number(this.orderrecordmain[column.property]).toFixed(
            2
          );
        }
      });
      return sums;
    },
    datechange(item) {
      if (item.length === 3) {
        this.querydate = [item[0], item[1]];
        this.querydate[0].setTime(
          this.querydate[0].getTime() + this.servicetime
        );
        this.querydate[1].setTime(
          this.querydate[1].getTime() + this.servicetime
        );
      }
      this.listQuery.querymodel.begintime = this.querydate[0];
      this.listQuery.querymodel.endtime = this.querydate[1];
      this.getList();
    },
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      GetPaydetailRecord(this.listQuery).then((res) => {
        this.orderrecordmain = res.maindata;
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
    edit(row) {
      this.buscost.dialogshow = true;
      this.buscost.isedit = true;
      this.buscost.editform = row;
    },
    savebuscostcomplete(item) {
      this.buscost.dialogshow = false;
      this.$message({
        message: "修改记账成功！",
        type: "success",
      });
      this.getList();
    },
    cancelbuscostcomplete() {
      this.buscost.dialogshow = false;
    },
    deleted(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleted({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    m_export() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        const filterVal = [];
        this.columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.value);
        });
        const exportquery = JSON.parse(JSON.stringify(this.listQuery));
        let index = 1;
        exportquery.pageIndex = 1;
        exportquery.pageSize = 1000000;
        exportquery.mergeSize = false;
        GetPaydetailRecord(exportquery).then((res) => {
          const orderrecordmain = res.maindata;
          orderrecordmain.GoodsName = "总计：";
          res.data.push(orderrecordmain);
          const data = res.data.map((v) =>
            filterVal.map((j) => {
              if (j === "index") {
                return index++;
              } else {
                return v[j];
              }
            })
          );
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "停车支付流水",
          });
          this.downloadLoading = false;
        });
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>